import { Badge } from '@/shared/components';
import type { PermissionGroup } from '../types/roles.types';

interface Props {
  groups: PermissionGroup[];
  total: number;
}

export function RolePermissionsPanel({ groups, total }: Props) {
  return (
    <div className="space-y-4">
      <h3 className="font-semibold">Permissions ({total})</h3>
      {groups.length === 0 ? (
        <p className="text-mp-muted text-sm">This role grants no permissions.</p>
      ) : (
        <div className="space-y-4">
          {groups.map((group) => (
            <div key={group.resource} className="border border-mp-border rounded p-3">
              <h4 className="font-medium mb-2">{group.resource}</h4>
              <ul className="flex flex-wrap gap-2">
                {group.permissions.map((permission) => (
                  <li key={permission.id}>
                    <Badge variant="info">{permission.name}</Badge>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
